export default "__VITE_ASSET__f03c2ec7__"